export enum FetchState {
    NotFetched = "NotFetched",
    Success = "Success",
    Error = "Error",
    Busy = "Busy"
}